import { Injectable } from '@angular/core';
import {Http, RequestOptions} from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import {config} from "../../../config/str";
import {Observable} from "rxjs/Observable";

@Injectable()
export class MapsService {

  public google: any;
  private accountingURL:string = config.StripeService;

  // AgmCoreModule.forRoot({ apiKey: 'AIzaSyDQa3jrP5XV8AhKadVa_7MmmlOGT9IL5XA' }),


  constructor(private http: Http) { }



  getLocation(address: string):Observable<any> {

    // console.log(address);

    const invoices = this.http.get(this.accountingURL+'getGeoLocCord/'+address)
      .map((res) => res.json())
      .catch((error:any) => Observable.throw(error.json().error || 'Server error'));

    return invoices;

  }


}



// WEBPACK FOOTER //
// ./src/app/shared/services/maps/maps.service.ts